import { SCOPE_TYPE, LOAD_STATUS } from '@/constants';
import { RESET_DATA_PANEL } from './constants';
// 更新整个state
export const UPDATE_WHOLE_STATE = 'update_whole_state';
export const UPDATE_VS_ACTIVITY_QUERY = 'update_vs_activity_query';
export const RESET_VS_ACTIVITY = 'RESET_VS_ACTIVITY';

export function actionUpdateWholeState(payload) {
  return {
    type: UPDATE_WHOLE_STATE,
    payload,
  };
}

export function updateVsActivityQuery() {
  return {
    type: UPDATE_VS_ACTIVITY_QUERY,
  };
}

export function resetVsActivity() {
  return {
    type: RESET_VS_ACTIVITY,
  };
}

const initialState = {
  // 数据渠道，小程序 全渠道 h5
  selectedChannel: '',
  // 选择的需要对比的活动
  selectedActivities: [null, null, null],
  // 选择的类型 活动 || 会场
  vsType: null,
  // 对比中状态 loding
  vsStatus: LOAD_STATUS.INIT,
  // 纬度 活动整体 活动日均
  scopeType: SCOPE_TYPE.ALL,
  // 获取的对比数据
  dataAll: [],
  // 平均数据
  dataAverage: [],
  // 需要传给后端的查询参数
  query: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_WHOLE_STATE:
      return Object.assign({}, state, payload);
    case UPDATE_VS_ACTIVITY_QUERY: {
      const activities = [];
      for (var i = 0, len = state.selectedActivities.length; i < len; i++) {
        if (!state.selectedActivities[i]) continue;
        activities.push({ code: state.selectedActivities[i].code });
      }
      const query = {
        dataType: state.scopeType,
        activities: activities,
        plant: state.selectedChannel,
        vsType: state.vsType,
      };
      return Object.assign({}, state, { query });
    }
    case RESET_DATA_PANEL:
    case RESET_VS_ACTIVITY:
      return initialState;
    default:
      return state;
  }
};
